import { cx } from "./util";

/** Square mono lowercase button with a hard offset shadow. Renders <a> when href is set. */
export default function Button({ variant = "primary", size = "md", arrow = false, brackets = false, href, className, children, ...rest }) {
  const Tag = href ? "a" : "button";
  return (
    <Tag href={href} className={cx("gd-btn", `gd-btn-${variant}`, size === "lg" && "gd-btn-lg", className)} {...rest}>
      {brackets && <span className="gd-br">[</span>}
      {children}
      {brackets && <span className="gd-br">]</span>}
      {arrow && <span aria-hidden="true">-&gt;</span>}
    </Tag>
  );
}
